export default {
  classId: (state) => state.classId,
  clientId: (state) => state.clientId,
  contactInformation: (state) => state.contactInformation,
  dob: (state) => state.dob,
  effectiveDate: (state) => state.effectiveDate,
  eyemedId: (state) => state.eyemedId,
  fileBoundId: (state) => state.fileBoundId,
  firstName: (state) => state.firstName,
  fullName: (state) => `${state.firstName} ${state.lastName}`,
  gender: (state) => state.gender,
  groupCk: (state) => state.groupCk,
  groupId: (state) => state.groupId,
  groupName: (state) => state.groupName,
  healthIdMatch: (state) => state.healthIdMatch,
  languageAssistance: (state) => state.languageAssistance,
  lastName: (state) => state.lastName,
  memberCk: (state) => state.memberCk,
  middleInitial: (state) => state.middleInitial,
  planId: (state) => state.planId,
  privacyAddress: (state) => state.privacyAddress,
  reportingCodes: (state) => state.reportingCodes,
  transaction: (state) => state.transaction,
  similarMembers: (state) => state.similarMembers,
  ssn: (state) => state.ssn,
  ssnMatch: (state) => state.ssnMatch,
  subGroupCk: (state) => state.subGroupCk,
  subGroupId: (state) => state.subGroupId,
  subGroupName: (state) => state.subGroupName,
  subscriber: (state) => state.subscriber,
  subscriberCk: (state) => state.subscriberCk,
  subscriberId: (state) => state.subscriberId,
  suffix: (state) => state.suffix,
  termDate: (state) => state.termDate,
}